import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { isDefaultMailbox } from 'owa-client-ids';
import { getUserConfiguration, getConnectedAccountUserConfiguration } from 'owa-session-store';

export default function getUserConfigurationForMailbox(
    primarySmtpAddress: string
): OwaUserConfiguration {
    if (isDefaultMailbox(primarySmtpAddress)) {
        return getUserConfiguration();
    } else {
        return getConnectedAccountUserConfiguration(primarySmtpAddress);
    }
}
